import React, { useCallback, useEffect } from "react";

import EnvService from "../../../services/env.service";
import RequestService from "../../../services/request.service";
import UrlService from "../../../services/url.service";

import LoadingPage from "../../../components/LoadingPage";

const LOGIN_PF_ENDPOINT = "login/pf/agcc";

function LoginPFWithAgcc() {
  const callServiceLoginPfAgcc = useCallback(async () => {
    console.log("Iniciando login");
    const { REACT_APP_GRAFENO_ROUTE_URL } = EnvService.getEnv();
    try {
      console.log(
        "Variavel REACT_APP_GRAFENO_ROUTE_URL" + REACT_APP_GRAFENO_ROUTE_URL
      );
      const redirect = UrlService.getQueryString("redirect_app_url");
      await RequestService.post(
        `${REACT_APP_GRAFENO_ROUTE_URL}/${LOGIN_PF_ENDPOINT}?redirect_app_url=${redirect}`
      );
      console.log("Redirect to ", redirect);
      window.location = redirect;
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadUserGcs = useCallback(async () => {
    try {
      callServiceLoginPfAgcc();
    } catch (e) {
      console.error(e);
    }
  }, [callServiceLoginPfAgcc]);

  useEffect(loadUserGcs, [loadUserGcs]);

  return <LoadingPage />;
}

export default LoginPFWithAgcc;
